<template lang="pug">
    .re-contact-hao
        .app-choice-group(v-if="!hasHao")
            .app-choice-group__label Указать новое основное заболевание?
            .app-userhoice-group__listusers
                app-choice(
                    v-model="addHao"
                    type="radio"
                    radio-value="0"
                    label="Нет"
                )
                app-choice(
                    v-model="addHao"
                    type="radio"
                    radio-value="1"
                    label="Да"
                )
        .re-contact-atopic-dermatitis__wrapper(:class="{disabled: !hasHao && addHao==='0'}")
            h4 Диагноз
            diagnoses-block(
                v-model="diagnoses"
                ref="diagnoses"
                with-hao-types
                is-re-contact
            )

            h4 Таргентная терапия
            target-therapy-block(
                v-model="targetTherapy"
                ref="targetTherapy"
                is-re-contact
            )

            h4 Базисная терапия
            therapy-block(
                v-model="basicTherapy"
                ref="basicTherapy"
                is-re-contact
            )

            h4 Обострения
            exacerbations-block(
                v-model="exacerbations"
                ref="exacerbations"
                with-cause
                nebulizer
                is-re-contact
            )

            h4 Нежелательные эффекты
            unwanted-effects-block(
                v-model="unwantedEffects"
                ref="unwantedEffects"
                is-re-contact
            )

            h4 Опросники
            questionnaires-angiooteki(
                v-model="questionnairesHao"
                ref="questionnairesHao"
                is-re-contact
            )

        .row.sticky-buttons-block
            app-button(
                large
                @click="saveAndContinue"
            ) Сохранить и продолжить заполнение
            app-button(
                :loading="saveLoading"
                large
                color="white"
                @click="saveAndClose"
            ) Сохранить и закончить заполнение
            app-link.app-link--red.app-link--left-margin(@click="close") Закрыть без сохранения
</template>

<script>
import TherapyBlock from '@/components/pages/patients/blocks/TherapyBlock';
import TargetTherapyBlock from '@/components/pages/patients/blocks/TargetTherapyBlock';
import DiagnosesBlock from '@/components/pages/patients/blocks/DiagnosesBlock';
import ExacerbationsBlock from '@/components/pages/patients/blocks/ExacerbationsBlock';
import QuestionnairesAngiooteki from '@/components/pages/patients/questionnaires/QuestionnairesAngiooteki';
import saving from '@/mixins/saving';
import UnwantedEffectsBlock from '@/components/pages/patients/blocks/UnwantedEffectsBlock';
import moment from 'moment';

export default {
    name: 're-contact-hao',

    components: {
        TherapyBlock,
        TargetTherapyBlock,
        DiagnosesBlock,
        ExacerbationsBlock,
        UnwantedEffectsBlock,
        QuestionnairesAngiooteki,
    },

    mixins: [saving],

    data: () => ({
        hasHao: false,
        addHao: '0',

        diagnoses: [],
        targetTherapy: [],
        basicTherapy: [],
        exacerbations: [],
        unwantedEffects: [],
        questionnairesHao: [],
    }),

    mounted() {
        if (this.lastData && !this.hasDataFromLocalStorage) {
            const hao = this.lastData.sicknesses.find(s => s.type === 'HEREDITARY_ANGIOOTEK');
            if (hao) {
                this.hasHao = true;

                this.diagnoses = this.$refs.diagnoses.getFormattedSavedFields(hao.diagnoses);

                this.targetTherapy = this.$refs.targetTherapy.getFormattedSavedFields(hao.target_therapies);

                this.basicTherapy = this.$refs.basicTherapy.getFormattedSavedFields(hao.basis_therapies);

                this.exacerbations = this.$refs.exacerbations.getFormattedSavedFields(hao.exacerbations);

                this.unwantedEffects = this.$refs.unwantedEffects.getFormattedSavedFields(hao.unwanted_effects);

                this.questionnairesHao = this.$refs.questionnairesHao.getFormattedSavedFields(hao.questionnaires);

                setTimeout(() => {
                    this.$refs.questionnairesHao.addNewQuestionnaires(+moment());
                });
            }
        }
    },

    methods: {
        getFormFields() {
            if (!this.hasHao && !+this.addHao) {
                return {};
            }
            return {
                hereditary_angiootek: {
                    diagnoses: this.$refs.diagnoses.getFieldsForSave(),
                    target_therapies: this.$refs.targetTherapy.getFieldsForSave(),
                    basis_therapies: this.$refs.basicTherapy.getFieldsForSave(),
                    exacerbations: this.$refs.exacerbations.getFieldsForSave(),
                    unwanted_effects: this.$refs.unwantedEffects.getFieldsForSave(),
                    questionnaires: this.$refs.questionnairesHao.getFieldsForSave(),
                },
            };
        },

        checkValid() {
            if (this.$refs.diagnoses.$v.$invalid
                || this.$refs.targetTherapy.$v.$invalid
                || this.$refs.basicTherapy.$v.$invalid
                || this.$refs.exacerbations.$v.$invalid
                || this.$refs.unwantedEffects.$v.$invalid
                || this.$refs.questionnairesHao.$v.$invalid) {
                this.$refs.diagnoses.$v.$touch();
                this.$refs.targetTherapy.$v.$touch();
                this.$refs.basicTherapy.$v.$touch();
                this.$refs.exacerbations.$v.$touch();
                this.$refs.unwantedEffects.$v.$touch();
                this.$refs.questionnairesHao.$v.$touch();
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.re-contact-hao {
    &__wrapper.disabled {
        opacity: 0.5;

        pointer-events: none;
    }

    @include mobile_or_P {
        max-width: 100vmin;
        margin: 0 auto;

        h4 {
            margin-bottom: 1rem;
        }
    }
}
</style>
